/**
 * Stories Map — frontend interaction
 *
 * Handles pin click → tooltip display and mobile load-more behaviour.
 * Scoped to the .gardp-stories-map wrapper rendered by the
 * [gardp_stories_map] shortcode.
 */
( function () {
	'use strict';

	/**
	 * Initialise a single stories-map instance.
	 *
	 * @param {Element} wrap  The .gardp-stories-map wrapper element.
	 */
	function initStoriesMap( wrap ) {
		var pins             = wrap.querySelectorAll( '.pin' );
		var pinTooltip       = wrap.querySelector( '#pin-tooltip' );
		var pinTooltipContent = wrap.querySelector( '#pin-tooltip-content' );
		var pinTooltipClose  = wrap.querySelector( '#pin-tooltip-close' );
		var storiesEl        = wrap.querySelector( '#stories' );

		if ( ! pins.length || ! pinTooltip || ! pinTooltipContent || ! pinTooltipClose || ! storiesEl ) {
			return;
		}

		// ----------------------------------------------------------------------
		// Staggered animation timings for the bouncing pins
		// ----------------------------------------------------------------------
		var animationSettings = [
			{ delay: '0s',   duration: '3s' },
			{ delay: '0.5s', duration: '2.5s' },
			{ delay: '1.5s', duration: '3.5s' },
			{ delay: '2s',   duration: '2s' },
			{ delay: '3s',   duration: '2.5s' },
			{ delay: '3.5s', duration: '3s' },
			{ delay: '4.5s', duration: '3.5s' },
			{ delay: '5s',   duration: '2.5s' },
			{ delay: '5.5s', duration: '3s' },
		];

		// ----------------------------------------------------------------------
		// Tooltip helpers
		// ----------------------------------------------------------------------
		function hideTooltip() {
			pinTooltip.classList.remove( 'visible' );
			pinTooltip.style.opacity = '0';
			pinTooltip.style.zIndex  = '0';
		}

		function showTooltip() {
			pinTooltip.classList.add( 'visible' );
			pinTooltip.style.opacity = '1';
			pinTooltip.style.zIndex  = '9';
		}

		pinTooltipClose.addEventListener( 'mouseup', hideTooltip );

		// ----------------------------------------------------------------------
		// Wire up each pin
		// ----------------------------------------------------------------------
		pins.forEach( function ( pin, index ) {
			var settings = animationSettings[ index % animationSettings.length ];
			pin.style.animationDelay    = settings.delay;
			pin.style.animationDuration = settings.duration;

			pin.addEventListener( 'mouseup', function () {
				var storyEl = storiesEl.querySelector( '[data-story="' + pin.dataset.story + '"]' );
				if ( storyEl ) {
					// innerHTML is server-rendered, theme-controlled content — not user input.
					pinTooltipContent.innerHTML = storyEl.innerHTML;
				}
				showTooltip();
			} );
		} );

		// ----------------------------------------------------------------------
		// Mobile load-more
		// ----------------------------------------------------------------------
		var currentIndex = 2;

		function loadMoreStories( event ) {
			event.preventDefault();
			var storyDivs = wrap.querySelectorAll( '#stories > div[data-story]' );
			var batchSize = 3;

			for ( var i = currentIndex; i < currentIndex + batchSize; i++ ) {
				if ( storyDivs[ i ] ) {
					storyDivs[ i ].style.display = 'block';
				}
			}

			currentIndex += batchSize;

			if ( currentIndex >= storyDivs.length ) {
				var btn = wrap.querySelector( '#loadMoreBtn' );
				if ( btn ) {
					btn.style.display = 'none';
				}
			}
		}

		var loadMoreBtn = wrap.querySelector( '#loadMoreBtn' );
		if ( loadMoreBtn ) {
			loadMoreBtn.addEventListener( 'click', loadMoreStories );
		}
	}

	// --------------------------------------------------------------------------
	// Bootstrap — init every map on the page
	// --------------------------------------------------------------------------
	function boot() {
		var wraps = document.querySelectorAll( '.gardp-stories-map' );
		wraps.forEach( function ( wrap ) {
			initStoriesMap( wrap );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}
} )();
